module.exports = __webpack_public_path__ + "static/reason-3-14b58cfd8de4643be8d1fef80752cb67.svg";